import { RespondCouncilAdminInvitationRequest } from "@/gen/api"
import { councilAdminInvitations } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export type UseRespondToInvitationParams = {
  onSuccess?: () => void
  onError?: (e: Error) => void
}

export type RespondToInvitationData = {
  token: string
  request: RespondCouncilAdminInvitationRequest
}

const useRespondToInvitation = (params: UseRespondToInvitationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...(params.onError ? { onError: params.onError } : {}),
    mutationFn: async (data: RespondToInvitationData) => {
      try {
        const response = await councilAdminInvitations.respondToInvitation(data.token, data.request)
        return response.data
      } catch (error: unknown) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error as { response?: { data?: { message?: string } } }
          if (err.response?.data?.message) {
            throw new Error(err.response.data.message)
          }
        }
        throw error
      }
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-invitations"] })
      queryClient.invalidateQueries({ queryKey: ["council-invitations"] })
      queryClient.invalidateQueries({ queryKey: ["invitation-statistics"] })
      queryClient.invalidateQueries({ queryKey: ["invitations-for-email"] })
      queryClient.invalidateQueries({ queryKey: ["invitations-sent-by-user"] })
      queryClient.invalidateQueries({ queryKey: ["invitation-by-token", variables.token] })
      queryClient.invalidateQueries({ queryKey: ["admins"] })
      params.onSuccess?.()
    },
  })
}

export default useRespondToInvitation
